// src/utils/formatUtils.js
// @ts-nocheck
// Format phone number to XXX-XXX-XXXX if it's 10 digits

export function formatPhoneNumber(phone) {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, ""); // Remove non-numeric characters
  return cleaned.length === 10
    ? `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
    : phone; // Return the original if it doesn't match expected length
}

export function formatPhonedata(phone) {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, ""); // Remove non-numeric characters

  const formats = [
    { length: 3, format: (num) => num }, // 3 digits: XXX
    { length: 6, format: (num) => `${num.slice(0, 3)}-${num.slice(3)}` }, // 4 to 6 digits: (XXX) XXX
    { length: 7, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6)}` }, // 7 digits: (XXX) XXX-XXXX
    { length: 8, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 8)}` }, // 8 digits: (XXX) XXX-XXXX
    { length: 9, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 9)}` }, // 9 digits: (XXX) XXX-XXXX
    { length: 10, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}` }, // 10 digits: (XXX) XXX-XXXX
    { length: 11, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10)}` }, // 11 digits: (XXX) XXX-XXXX x XXXX
    { length: 12, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 12)}` }, // 12 digits: (XXX) XXX-XXXX x XXXX
    { length: 13, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 13)}` }, // 13 digits: (XXX) XXX-XXXXXXXX
    { length: 14, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 14)}` }, // 14 digits: (XXX) XXX-XXXXXXXX
    { length: 15, format: (num) => `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 15)}` } // 15 digits: (XXX) XXX-XXXX x XXXXX
  ];

  const format = formats.find(f => cleaned.length === f.length);
  return format ? format.format(cleaned) : phone;
}

export function formatPhone(phone) {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, ""); // Remove non-numeric characters

  const formats = [
    { length: 3, format: (num) => num }, // 3 digits: XXX
    { length: 6, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3)}` }, // 4 to 6 digits: (XXX) XXX
    { length: 7, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}` }, // 7 digits: (XXX) XXX-XXXX
    { length: 8, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 8)}` }, // 8 digits: (XXX) XXX-XXXX
    { length: 9, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 9)}` }, // 9 digits: (XXX) XXX-XXXX
    { length: 10, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}` }, // 10 digits: (XXX) XXX-XXXX
    { length: 11, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10)}` }, // 11 digits: (XXX) XXX-XXXX x XXXX
    { length: 12, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 12)}` }, // 12 digits: (XXX) XXX-XXXX x XXXX
    { length: 13, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 13)}` }, // 13 digits: (XXX) XXX-XXXXXXXX
    { length: 14, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 14)}` }, // 14 digits: (XXX) XXX-XXXXXXXX
    { length: 15, format: (num) => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}${num.slice(10, 15)}` } // 15 digits: (XXX) XXX-XXXX x XXXXX
  ];

  const format = formats.find(f => cleaned.length === f.length);
  return format ? format.format(cleaned) : phone;
}
export function einNumber(ein: string) {
  if (!ein) return ""; // Return empty string if EIN is empty or falsy

  // Remove all non-numeric characters
  const cleaned = ein.replace(/\D/g, "");

  // Format progressively as the user types
  if (cleaned.length <= 2) {
    return cleaned; // First 2 digits
  } else if (cleaned.length <= 9) {
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`; // Format: XX-XXXXXXX
  }

  return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 9)}`; // Trim to max length
}

export function ssNumber(ssn) {
  if (!ssn) return ""; // Return empty string if ssn is empty or falsy

  // Remove all non-numeric characters
  const cleaned = ssn.replace(/\D/g, "");

  // Format progressively as the user types
  if (cleaned.length <= 3) {
    return cleaned; // First part: just the first 3 digits
  } else if (cleaned.length <= 5) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}`; // Add dash after 3 digits
  } else if (cleaned.length <= 7) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5, 7)}`; // Add dash after 5 digits
  } else if (cleaned.length <= 9) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5, 9)}`; // Final format: XX-XX-XXXX
  }

  return ssn; // Return the original input if it's not valid
}
// Format ZIP code with options for XXXXX or XXXXX-XXXX
export function formatZipCode(zip) {
  if (!zip) return "";
  const zipData = zip.replace('-0000', '')
  const cleaned = zipData.replace(/\D/g, ""); // Remove non-numeric characters
  if (cleaned.length === 5) {
    return `${cleaned}`; // Default to 0000 for 5-digit ZIP
  } else if (cleaned.length > 5) {
    return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`; // Default to 0000 for 5-digit ZIP
  }
  else if (cleaned.length === 9) {
    return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`; // Format as XXXXX-XXXX
  }
  return zip; // Return original if doesn't match expected length
}

// Capitalize the first letter of a string
export function capitalize(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
}


export const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0; // Generate a random number
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // Adjust for 'x' or 'y'
    return v.toString(16); // Convert to hexadecimal
  });
};

export const numberToWords = (num) => {
  if (num === 0) return "Zero";

  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];
  const thousands = [
    "", "Thousand", "Million", "Billion", "Trillion"
  ];

  const convert = (n) => {
    if (n === 0) return "";
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
  };

  let result = "";
  let i = 0;

  while (num > 0) {
    if (num % 1000 !== 0) {
      result = convert(num % 1000) + " " + thousands[i] + " " + result;
    }
    num = Math.floor(num / 1000);
    i++;
  }

  return result.trim();
};